module.exports = __webpack_public_path__ + "static/media/headsprout.ea8035da.jpg";